import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/images/icon_admin_login.png';
import _imports_1 from '@/assets/images/icon_menu_list.png';
const _hoisted_1 = {
  class: "layout-container"
};
const _hoisted_2 = {
  class: "app-menu"
};
const _hoisted_3 = {
  class: "header-top flex-between"
};
import UserBar from '@/layout/components/user-bar.vue';
import TagView from '@/layout/components/tags-view/tags-view.vue';
import AppMenu from '@/layout/components/menu/app-menu.vue';
const s = 1;
export default /*@__PURE__*/_defineComponent({
  __name: 'layout-index',
  setup(__props) {
    return (_ctx, _cache) => {
      const _component_el_aside = _resolveComponent("el-aside");
      const _component_el_header = _resolveComponent("el-header");
      const _component_router_view = _resolveComponent("router-view");
      const _component_el_main = _resolveComponent("el-main");
      const _component_el_container = _resolveComponent("el-container");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_container, {
        class: "hw-100"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_aside, {
          width: "260px",
          class: "aside"
        }, {
          default: _withCtx(() => [_cache[0] || (_cache[0] = _createElementVNode("div", {
            class: "logo-box flex-vh-center"
          }, [_createElementVNode("img", {
            src: _imports_0,
            class: "logo-img"
          })], -1)), _createElementVNode("div", _hoisted_2, [_createVNode(AppMenu)])]),
          _: 1
        }), _createVNode(_component_el_container, {
          class: "hw-100"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_header, {
            class: "header"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_cache[1] || (_cache[1] = _createElementVNode("div", {
              class: "flex align-center"
            }, [_createElementVNode("img", {
              src: _imports_1,
              class: "header-menu-img"
            }), _createElementVNode("div", {
              class: "cl-000 fz-14 ml-10"
            }, "学校管理")], -1)), _createVNode(UserBar)]), _cache[2] || (_cache[2] = _createElementVNode("div", {
              class: "header-line"
            }, null, -1)), _createVNode(TagView)]),
            _: 1
          }), _createVNode(_component_el_main, {
            class: "main"
          }, {
            default: _withCtx(() => [_createVNode(_component_router_view)]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      })]);
    };
  }
});